import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateNoticeAnnouncement } from '@services/registry';

export function useUpdateNotice({ tenantId }) {
    const qc = useQueryClient();

    return useMutation({
        mutationFn: async ({ noticeId, noticeType, patch }) => {
            return await updateNoticeAnnouncement({ tenantId, noticeId, noticeType, patch });
        },
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['notices', tenantId] });
        },
    });
}
